import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=dd2e07a4&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=ts"
export * from "./MessageCenter.vue?vue&type=script&lang=ts"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=dd2e07a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2e07a4",
  null
  
)

export default component.exports